export const healthParameters = [
  {
    label: "BLOOD PRESSURE (mmHg) Systolic",
    name: "blood_pressure_systolic",
    type: "number",
  },
  {
    label: "BLOOD PRESSURE (mmHg) Diastolic",
    name: "blood_pressure_diastolic",
    type: "number",
  },
  {
    label: "PULSE RATE (BPM)",
    name: "pulse_rate",
    type: "number",
  },
  {
    label: "BLOOD SUGAR LEVEL (mg/dL) Random",
    name: "blood_sugar_random",
    type: "number",
  },
  {
    label: "BODY WEIGHT (Kg)",
    name: "body_weight",
    type: "number",
  },
  {
    label: "BMI",
    name: "bmi",
    type: "number",
  },
  {
    label: "BODY FAT (%)",
    name: "body_fat",
    type: "number",
  },
  {
    label: "MUSCLE RATE (%)",
    name: "muscle_rate",
    type: "number",
  },
  {
    label: "BODY WATER (%)",
    name: "body_water",
    type: "number",
  },
  {
    label: "BONE MASS (Kg)",
    name: "bone_mass",
    type: "number",
  },
  {
    label: "BMR (Kcal)",
    name: "bmr",
    type: "number",
  },
  {
    label: "METABOLIC AGE (Years)",
    name: "metabolic_age",
    type: "number",
  },
  {
    label: "VISCERAL FAT (%)",
    name: "visceral_fat",
    type: "number",
  },
  {
    label: "SUBCUTANEOUS FAT (%)",
    name: "subcutaneous_fat",
    type: "number",
  },
  {
    label: "PROTEIN MASS (Kg)",
    name: "protein_mass",
    type: "number",
  },
  {
    label: "MUSCLE MASS (Kg)",
    name: "muscle_mass",
    type: "number",
  },
  {
    label: "WEIGHT WITHOUT FAT (Kg)",
    name: "weight_witout_fat",
    type: "number",
  },
  {
    label: "OBESITY LEVEL",
    name: "obesity_level",
    type: "text",
  },
  {
    label: "SKELETAL MUSCLE MASS (Kg)",
    name: "skeletal_muscle_mass",
    type: "number",
  },
  {
    label: "IDEAL BODY WEIGHT (Kg)",
    name: "ideal_body_weight",
    type: "number",
  },
  {
    label: "WATER WEIGHT (Kg)",
    name: "water_weight",
    type: "number",
  },
  {
    label: "OBESITY GRADE",
    name: "obesity_grade",
    type: "text",
  },
  {
    label: "FAT MASS (Kg)",
    name: "fat_mass",
    type: "number",
  },
  {
    label: "BODY SCORE",
    name: "body_score",
    type: "number",
  },
];

export const activity = [
  "Sedentary (Sitting, office work)",
  "Lightly Active (Light exercise/sports 1-3 days/week)",
  "Moderately Active (Moderate exercise/sports 3-5 days/week)",
  "Very Active (Hard exercise/sports 6-7 days/week)",
  "Extra Active (Very hard exercise or physical job + training)",
];
